import { render, staticRenderFns } from "./detailPutaway.vue?vue&type=template&id=72137f58"
import script from "./detailPutaway.vue?vue&type=script&lang=js"
export * from "./detailPutaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports